import BaseError from "./BaseError";

export default class ServiceUnavailableError extends BaseError {
  constructor(data) {
    super(data);
    this.name = "ServiceUnavailableError";
  }
}
